import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { ComponentsPartnerKreditdataInviteButton, InfoDialog, Spacer } from 'components';
import { useSelector } from 'react-redux';
import { mediaQueries, untilSmallMediaQuery, untilTabletMediaQuery } from 'utils/MediaQueriesDeprecated';
import getConfig from 'next/config';
import { hasRateLimitPeriodExpired, rateLimitPeriodExpiresInDays } from 'utils/uniifyUtils';

const {
    publicRuntimeConfig: { kreditDataIntegration },
} = getConfig();

const UploadPartnerPensionModal = ({ closeModal, ...props }) => {
    const email = props.partnerEmail;
    const { emailSent } = props;
    const user = useSelector(state => state.user);
    const history = user?.integrations?.kreditdata_partner?.history ?? [];
    const fileType = 'PensionsInfoFile';
    const canUseUniify = hasRateLimitPeriodExpired(history, fileType, email).hasExpired;
    const showHelpText = true; // documents.filter(x => x.fileType === 'PensionsInfoFile' && x.content?.source === 'api').length > 0;
    const daysUntilExpiration = useMemo(() => kreditDataIntegration && rateLimitPeriodExpiresInDays(history, fileType), [history]);
    const buttonText2 = mediaQueries(untilSmallMediaQuery) ? 'Send invitation' : 'Send invitation til at hente pensionsoplysninger';
    const buttonSize = mediaQueries(untilTabletMediaQuery) ? 'tiny' : 'medium';

    const handleSuccess = (result) => {
        props.onSuccess(result);
        closeModal();
    };

    return (
        <InfoDialog
            modal={ true }
            showClose={ true }
            onClose={ closeModal }
            headerContent={ <h3>{ buttonText2 }</h3> }
            modalContent={
                <div style={{ marginTop: 20, marginBottom: 20 }}>

                    { canUseUniify? <>
                        <p>
                            Din partner vil modtage en email på adressen <strong>{ email }</strong> med et link til at hente data fra PensionsInfo. Her vil din partner blive bedt om at logge på med MitID. Når pensionsoplysningerne er indhentet
                            vil de kunne tilgås på din profil.
                        </p>
                        <p>
                            <strong>OBS!</strong> Husk at bruge din partners MitID når i logger ind hos PensionsInfo.
                        </p>
                        <ComponentsPartnerKreditdataInviteButton inputId="pensionReportFile" flow="pensionsInfo" size={ buttonSize } onSuccess={ handleSuccess } partnerEmail={ email }>
                            { buttonText2 }
                        </ComponentsPartnerKreditdataInviteButton>

                    </> : <>
                        <p>Vi har modtaget pensionsdata fra din partner.</p>
                        <p>Du kan hente nye pensionsoplysninger fra din partner igen om <strong>{ daysUntilExpiration } </strong>dage.</p>
                    </>

                    }

                    { showHelpText && (
                        <>
                            <Spacer />
                            <p>
                                Oplever du problemer? Kontakt os venligst på{ ' ' }
                                <a style={{ display: 'inline' }} href={ 'mailto:kontakt@penly.dk' }>
                                    { ' ' }
                                    kontakt@penly.dk{ ' ' }
                                </a>{ ' ' }
                                og undlad at prøve at hente pensionsoplysninger flere gange.
                            </p>
                        </>
                    ) }
                </div>
            }
        />
    );
};

UploadPartnerPensionModal.propTypes = {
    closeModal: PropTypes.func.isRequired,
};

export default UploadPartnerPensionModal;
